import { GenericModel } from './generic.model';

export interface Grade {
  id: number;
  description: string;
  level: GenericModel;
}
